export const LIST_FILTER_LOCALE_ZHCHT = {
    filter: 'ç¯©é¸',
    confirm: 'ç¢ºå®',
    cancel: 'åæ¶',
    reset: 'æ¸ç©ºæ¢ä»¶'
};
